<template>
  <div class="container">
    <div class="buttons-container">
      <div class="buttons" ref="buttons">
        <div class="buttons-tracker" :style="`transform: translateX(${trackerPosition}px); min-width: ${buttonWidth}px; bottom: ${requireScrollbar() ? '8px' : '0'}`"></div>
        <button 
        v-for="(tab, index) in tabs" 
        :key="index" 
        class="buttons-button" 
        :style="`min-width: ${buttonWidth}px; max-width: ${buttonWidth}px; padding-bottom: ${requireScrollbar() ? '8px' : '0'}`"
        @click="$emit('change', index); currentIndex = index; updateScroll();"
        :class="currentPath.substring(currentPath.lastIndexOf('/'), currentPath.length) === tab.route ? 'buttons-button-active' : ''" 
        >
          <div class="buttons-button-image">
            <img :src="`${previewsServer}/textures/ui/new/${getImage(tab)}`"/>
          </div>
          <div class="buttons-button-label" :style="`min-width: ${buttonWidth}px; max-width: ${buttonWidth}px`">
            <span>{{ tab.name }}</span>
          </div>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: "TabSelectorNoScrolling",

  props: {
    tabs: {
      type: Array,
      default: () => []
    }
  },

  emits: ['change'],

  data () {
    return {
      previewsServer: import.meta.env.VITE_VUE_APP_PREVIEWS_SERVER,
      buttonWidth: 0,
    }
  },

  computed: {
    ...mapGetters({
      currentPath: 'getCurrentPath',
    }),
    trackerPosition() {
      return this.realTrackerPosition() * (this.buttonWidth + 8);
    }
  },

  methods: {
    realTrackerPosition() {
      return this.tabs.findIndex(tab => this.currentPath.substring(this.currentPath.lastIndexOf('/'), this.currentPath.length) === tab.route);
    },
    getImage(tab) {
      if (tab.image) {
        return tab.image;
      } else {
        return tab.name.toLowerCase() + '.jpg';
      }
    },
    requireScrollbar() {
      return this.tabs.length > 4;
    },
    updateScroll() {
      setTimeout(() => {
        document.querySelector('.buttons-container').scrollLeft = (this.currentIndex * (this.buttonWidth + 8) + this.buttonWidth / 2) - (document.querySelector('.buttons-container').clientWidth / 2);
      }, 100);
    }
  },

  mounted() {
    // console.log('hier', 'mounted', this.tabs, this.$refs.buttons.clientWidth)
    this.buttonWidth = (this.$refs.buttons.clientWidth - 3*8) / 4
    this.$el.style.setProperty('--scrollbar-button-bg-left', `url(${this.previewsServer}/textures/ui/new/left.png)`)
    this.$el.style.setProperty('--scrollbar-button-bg-right', `url(${this.previewsServer}/textures/ui/new/right.png)`)
  }
}
</script>

<style lang="scss" scoped>

.container {
  width: 100%;
  border: 2px solid $c-border-1;
  border-radius: $radius-m;
  box-sizing: border-box;
  padding: 8px;
  position: relative;
}

.buttons {
  width: 100%;
  display: flex;
  gap: 8px;
  position: relative; 

  &-container {
    min-height: 100px;
    width: 100%;
    overflow-x: auto;
    z-index: 99;
    scroll-behavior: smooth;

    &::-webkit-scrollbar {
      height: 18px;
    }

    &::-webkit-scrollbar-track {
      background: $c-secondary;
      border: 7px solid transparent;
      background-clip: content-box;
      border-radius: $radius-l;
    }

    &::-webkit-scrollbar-thumb {
      background-color: $c-primary;
      border-radius: $radius-l;
      border: 1px solid transparent;
      background-clip: content-box;
    }

    &::-webkit-scrollbar-button {
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      width: 16px;
      height: 16px;
    }

    &::-webkit-scrollbar-button:start:decrement {
      background-image: var(--scrollbar-button-bg-left);
    }

    &::-webkit-scrollbar-button:end:increment {
      background-image: var(--scrollbar-button-bg-right);
    }
  }

  &-button {
    border: none;
    background: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    gap: 8px;
    padding: 0px;


    &-label {
      background-color: $c-border-1;
      border-radius: $radius-m;
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 56px;
      max-height: 56px;
    }

    &-image {
      max-width: calc(100% - 16px);
      min-width: calc(100% - 16px);
      height: 105px;
      display: flex;
      align-items: center;
      justify-content: center;

       @media (max-width: 999px) {
        height: 80px;
      }
    }

    & img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }

    &-active {
      & span {
        color: $c-secondary !important;
      }
    }

    & span {
      font-family: 'Oswald', sans-serif;
      color: $c-primary;
      font-weight: 700;
      font-size: 19px;
      text-transform: uppercase;
      z-index: 2;
      position: relative;
      display: flex;
      transition: color 0.3s ease-in-out;
      text-wrap: stable;
      max-width: 90%;
      
      @media (max-width: 999px) {
        font-size: 14px;
      }
    }
  }

  &-tracker {
    height: 56px;
    background-color: $c-primary;
    border-radius: $radius-m;
    position: absolute;
    transition: transform 0.3s ease-in-out;
    z-index: 2;
  }
}

</style>